//#region Get Course Select List

import { SelectListDto } from "../../models";

export const GET_COURSE_SELECT_LIST = "GET_COURSE_SELECT_LIST";
export const GET_COURSE_SELECT_LIST_SUCCESS: any =
  "GET_COURSE_SELECT_LIST_SUCCESS";
export const GET_COURSE_SELECT_LIST_ERROR: any = "GET_COURSE_SELECT_LIST_ERROR";
export const RESET_COURSE_SELECT_LIST: any = "RESET_COURSE_SELECT_LIST";

export interface GetCourseSelectListAction {
  type: typeof GET_COURSE_SELECT_LIST;
  payload: null;
}

export interface GetCourseSelectListSuccessAction {
  type: typeof GET_COURSE_SELECT_LIST_SUCCESS;
  payload: SelectListDto[];
}

export interface GetCourseSelectListErrorAction {
  type: typeof GET_COURSE_SELECT_LIST_ERROR;
  payload: any;
}

export interface ResetCourseSelectListAction {
  type: typeof RESET_COURSE_SELECT_LIST;
  payload: any;
}

//#endregion

//#region Get Course and Grades Select List

export const GET_COURSE_AND_GRADES_SELECT_LIST =
  "GET_COURSE_AND_GRADES_SELECT_LIST";
export const GET_COURSE_AND_GRADES_SELECT_LIST_SUCCESS: any =
  "GET_COURSE_AND_GRADES_SELECT_LIST_SUCCESS";
export const GET_COURSE_AND_GRADES_SELECT_LIST_ERROR: any =
  "GET_COURSE_AND_GRADES_SELECT_LIST_ERROR";
export const RESET_COURSE_AND_GRADES_SELECT_LIST: any =
  "RESET_COURSE_AND_GRADES_SELECT_LIST";

export interface GetCourseAndGradesSelectListAction {
  type: typeof GET_COURSE_AND_GRADES_SELECT_LIST;
  payload: null;
}

export interface GetCourseAndGradesSelectListSuccessAction {
  type: typeof GET_COURSE_AND_GRADES_SELECT_LIST_SUCCESS;
  payload: SelectListDto[];
}

export interface GetCourseAndGradesSelectListErrorAction {
  type: typeof GET_COURSE_AND_GRADES_SELECT_LIST_ERROR;
  payload: any;
}

export interface ResetCourseAndGradesSelectListAction {
  type: typeof RESET_COURSE_AND_GRADES_SELECT_LIST;
  payload: any;
}

//#endregion

//#region Get Course Select List Local

export const GET_COURSE_SELECT_LIST_LOCAL = "GET_COURSE_SELECT_LIST_LOCAL";
export const GET_COURSE_SELECT_LIST_LOCAL_SUCCESS: any =
  "GET_COURSE_SELECT_LIST_LOCAL_SUCCESS";
export const GET_COURSE_SELECT_LIST_LOCAL_ERROR: any =
  "GET_COURSE_SELECT_LIST_LOCAL_ERROR";
export const RESET_COURSE_SELECT_LIST_LOCAL: any =
  "RESET_COURSE_SELECT_LIST_LOCAL";

export interface GetCourseSelectListLocalAction {
  type: typeof GET_COURSE_SELECT_LIST_LOCAL;
  payload: null;
}

export interface GetCourseSelectListLocalSuccessAction {
  type: typeof GET_COURSE_SELECT_LIST_LOCAL_SUCCESS;
  payload: SelectListDto[];
}

export interface GetCourseSelectListLocalErrorAction {
  type: typeof GET_COURSE_SELECT_LIST_LOCAL_ERROR;
  payload: any;
}

export interface ResetCourseSelectListLocalAction {
  type: typeof RESET_COURSE_SELECT_LIST_LOCAL;
  payload: any;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetCourseSelectListAction
  | GetCourseSelectListSuccessAction
  | GetCourseSelectListErrorAction
  | GetCourseAndGradesSelectListAction
  | GetCourseAndGradesSelectListSuccessAction
  | GetCourseAndGradesSelectListErrorAction
  | GetCourseSelectListLocalAction
  | GetCourseSelectListLocalSuccessAction
  | GetCourseSelectListLocalErrorAction
  | ResetCourseSelectListLocalAction;
